'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _snakeCase = require('lodash/snakeCase');

var _snakeCase2 = _interopRequireDefault(_snakeCase);

var _client = require('../../utils/client');

var _localStorage = require('constructicon/lib/localStorage');

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProviderOauthButton = function (_Component) {
  _inherits(ProviderOauthButton, _Component);

  function ProviderOauthButton(props) {
    _classCallCheck(this, ProviderOauthButton);

    var _this = _possibleConstructorReturn(this, (ProviderOauthButton.__proto__ || Object.getPrototypeOf(ProviderOauthButton)).call(this, props));

    _this.handleAuth = _this.handleAuth.bind(_this);
    _this.providerUrl = _this.providerUrl.bind(_this);

    _this.state = {
      status: 'empty'
    };
    return _this;
  }

  _createClass(ProviderOauthButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.localStoragePoll);
      clearInterval(this.isPopupClosed);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onSuccess = _props.onSuccess,
          popup = _props.popup,
          provider = _props.provider,
          redirectUri = _props.redirectUri,
          useLocalStorage = _props.useLocalStorage;


      if (popup && typeof onSuccess === 'function') {
        if (useLocalStorage) {
          var key = 'app-oauth-state-' + provider;
          var hash = this.parseOauthHash(window.location.hash);

          if (hash.access_token) {
            (0, _localStorage.setLocalStorageItem)(key, hash);
            window.opener && window.close();
          } else {
            (0, _localStorage.setLocalStorageItem)(key, {});

            this.localStoragePoll = setInterval(function () {
              var oauthState = (0, _localStorage.getLocalStorageItem)(key);
              if (oauthState.access_token) {
                clearInterval(_this2.localStoragePoll);
                _this2.setState({ status: 'fetched' });
                return onSuccess(oauthState);
              }
            }, 1000);
          }
        } else {
          var _window = window,
              addEventListener = _window.addEventListener;

          var validSourceOrigin = redirectUri && new _urlParse2.default(redirectUri).origin;

          addEventListener('message', function (event) {
            if (event.origin !== validSourceOrigin) {
              return;
            }
            setTimeout(function () {
              return _this2.setState({ status: 'fetched' });
            }, 500);
            return onSuccess(event.data);
          }, false);
        }
      }
    }
  }, {
    key: 'handleAuth',
    value: function handleAuth() {
      var _this3 = this;

      var _props2 = this.props,
          popupWindowFeatures = _props2.popupWindowFeatures,
          provider = _props2.provider,
          onClose = _props2.onClose;


      var popupWindow = window.open(this.providerUrl(), provider + 'Auth', popupWindowFeatures);

      this.setState({ status: 'loading' });

      this.isPopupClosed = setInterval(function () {
        if (popupWindow.closed) {
          clearInterval(_this3.isPopupClosed);
          _this3.setState({ status: 'empty' });

          if (typeof onClose === 'function') {
            return onClose(popupWindow);
          }
        }
      }, 500);
    }
  }, {
    key: 'providerUrl',
    value: function providerUrl() {
      var _props3 = this.props,
          clientId = _props3.clientId,
          provider = _props3.provider,
          redirectUri = _props3.redirectUri;


      var params = {
        clientId: clientId,
        forceProvider: provider,
        redirectUri: redirectUri,
        responseType: 'token'
      };

      var urlParams = Object.keys(params).map(function (key) {
        return (0, _snakeCase2.default)(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');

      return (0, _client.getBaseURL)() + '/oauth/authorize?' + urlParams;
    }
  }, {
    key: 'parseOauthHash',
    value: function parseOauthHash(hash) {
      return hash.substring(1).split('&').reduce(function (params, part) {
        var item = part.split('=');
        params[decodeURIComponent(item[0])] = decodeURIComponent(item[1]);
        return params;
      }, {});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          label = _props4.label,
          popup = _props4.popup,
          provider = _props4.provider,
          props = _objectWithoutProperties(_props4, ['label', 'popup', 'provider']);

      var status = this.state.status;

      var isLoading = status === 'loading';
      var icon = isLoading ? 'loading' : status === 'fetched' ? 'check' : provider;

      if ((0, _client.isJustGiving)()) {
        return null;
      }

      var actionProps = popup ? {
        onClick: function onClick(e) {
          return _this4.handleAuth();
        }
      } : {
        href: this.providerUrl(),
        tag: 'a'
      };

      return _react2.default.createElement(
        _button2.default,
        _extends({
          'aria-label': label,
          background: provider,
          disabled: isLoading
        }, actionProps, (0, _omit2.default)(props, ['clientId', 'onClose', 'onSuccess', 'popupWindowFeatures', 'redirectUri', 'useLocalStorage'])),
        _react2.default.createElement(_icon2.default, { name: icon, spin: isLoading, size: 1.5 }),
        _react2.default.createElement(
          'span',
          null,
          label
        )
      );
    }
  }]);

  return ProviderOauthButton;
}(_react.Component);

ProviderOauthButton.propTypes = {
  /**
   * The EDH OAuthApplication client ID
   */
  clientId: _propTypes2.default.string.isRequired,

  /**
   * Button label
   */
  label: _propTypes2.default.any,

  /**
   * The onClose event handler if popup is closed
   */
  onClose: _propTypes2.default.func,

  /**
   * The onSuccess event handler if using a popup
   */
  onSuccess: _propTypes2.default.func,

  /**
   * Whether to handle with a popup
   */
  popup: _propTypes2.default.bool,

  /**
   * The features for the popup window (see https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Window_features)
   */
  popupWindowFeatures: _propTypes2.default.string,

  /**
   * The third-party provider to connect with
   */
  provider: _propTypes2.default.oneOf(['facebook', 'mapmyfitness', 'strava', 'fitbit']),

  /**
   * A valid return_to url for the specified EDH OAuthApplication
   */
  redirectUri: _propTypes2.default.string.isRequired
};

ProviderOauthButton.defaultProps = {
  label: 'Login with Facebook',
  popup: true,
  popupWindowFeatures: 'width=800,height=600,status=1',
  provider: 'facebook'
};

exports.default = ProviderOauthButton;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/provider-oauth-button/index.js
// module id = 1355
// module chunks = 0